import './opaenTime.css'
import React from 'react'
import Location from '../Location/Location'

function OpaenTime() {
  return (
    <div className='opeantime ' id='opeantimeid'>
         <div className='box  mb-0'>
        <div className="container">
            <div className="row">
            <div className="col-lg-4 col-md-12 text-center op mb-4 mt-4">
            <i class="fas fa-clock map"></i>
                <p>أوقات العمل</p>
                <a href="https://maps.app.goo.gl/6si4kQ46iMae3YPp9" rel="noopener noreferrer" target="_blank">كل يوم من  ٨ صباحاً  -  ١١ مساءً </a>
                </div>
            <div className="col-lg-4 col-md-12 text-center op mb-4 mt-4" >
            <i class="fas fa-map-marker-alt map"></i>
                <p>العنوان</p>
                <a href="https://maps.app.goo.gl/6si4kQ46iMae3YPp9" rel="noopener noreferrer" target="_blank">حي المنتزة، بريدة 42381</a>
                </div>
                <div className="col-lg-4 col-md-12 text-center op mb-4 mt-4">
                <i className="fas fa-phone pr-2 map"></i>
                <p>للتواصل والشكاوي</p>
                <a href="tel:0552092011">0552092011</a>
                </div>
            </div>
        </div>
    </div>
      <Location />
    </div>
  )
}

export default OpaenTime